__turbopack_context__.v({
  "badges": "styles-module-scss-module__14TJNq__badges",
  "note": "styles-module-scss-module__14TJNq__note",
  "pill": "styles-module-scss-module__14TJNq__pill",
});
